import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";

/** Barra de cada tela: voltar (opcional), título com o contexto ao lado e as ações à direita. Uma linha só. */
export function CabecalhoTela({ titulo, sobre, contexto, voltar, acoes }: {
  titulo: ReactNode;
  /** Linha acima do título, ex.: número do processo. */
  sobre?: ReactNode;
  contexto?: ReactNode;
  voltar?: { para: string; rotulo: string };
  acoes?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3 pb-4">
      <div className="min-w-0">
        {voltar && (
          <Link to={voltar.para} className="mb-2 inline-flex items-center gap-1 text-meta text-texto-3 hover:text-texto-1">
            <ArrowLeft size={14} aria-hidden /> {voltar.rotulo}
          </Link>
        )}
        {sobre && <div className="text-meta text-texto-3">{sobre}</div>}
        <div className="flex flex-wrap items-baseline gap-x-3">
          <h1 className="text-titulo font-medium break-words text-texto-1">{titulo}</h1>
          {contexto && <span className="text-meta text-texto-3">{contexto}</span>}
        </div>
      </div>
      {acoes && <div className="flex shrink-0 flex-wrap items-center gap-2">{acoes}</div>}
    </header>
  );
}
